/**
 * Общи условия / Terms. The Bulgarian is the authoritative text; the English
 * is a translation of it. Claims carry a `verified:` comment naming the file
 * that makes them true. The "last updated" date is this file's last commit.
 */

import { Link } from 'react-router'

export function TermsBg() {
  return (
    <>
      <h2>Какво е сайтът</h2>
      <p>
        {/* verified: CLAUDE.md (free, no advertising); src/shared/site-notice.ts */}
        „Чети по реда“ е неофициален фен каталог на реда за четене на големи фентъзи светове. Безплатен е и няма реклами. Не е свързан с
        авторите, наследниците им или издателите.
      </p>

      <h2>Чие е съдържанието</h2>
      <p>
        {/* verified: seeds/works.discworld.json (_synopsis_provenance: every synopsis written for this project) */}
        Бележките, резюметата и подредбата на пътищата са написани за този сайт. Книгите, заглавията им и преводите им принадлежат на
        техните носители на права.
      </p>

      <h2>Профил</h2>
      <p>
        {/* verified: src/worker/auth.ts (requireEmailVerification; user.deleteUser enabled); src/app/routes/Account.tsx */}
        Профилът е по желание — каталогът се чете и без него. Регистрацията иска потвърден имейл. Можете да изтриете профила си по всяко
        време от страницата <Link to="/account">Профил</Link>.{' '}
        {/* verified: .claude/skills/legal-pages/SKILL.md (digital-consent age 14; no age check is built, and none should be) */}
        Профили не се предлагат на деца под 14 години без съгласието на родител. Ако разберем, че профил принадлежи на дете под 14
        години, ще го изтрием.
      </p>

      <h2>Когато читателите пишат</h2>
      <p>
        {/* Approved by the maintainer, 30 Sep (reviews, #89). verified: src/worker/routes/reviews.ts (removal requires a reason, and the reason is emailed to the author at the account's address); tests/e2e/reviews.spec.ts. Discussion threads are still not built; the section covers them if they ever open. */}
        Тази част важи за отзивите на страниците на книгите, а също и за обсъжданията, ако на сайта се появят такива. Не се допускат
        обиди, спам и разкриване на сюжета без предупреждение. Поддържащият сайта може да премахне всяко написано нещо. Ако премахне
        ваш отзив, ви изпраща причината по имейл, на адреса на профила ви.
      </p>
      <p>
        {/* The maintainer's final wording (strikes, #89), 5 Oct. verified: src/shared/reviews.ts (writingState); src/worker/routes/reviews.ts */}
        След второто премахване на отзив не може да пишете и редактирате отзиви 30 дни, а след третото — вече не може да пишете отзиви
        в сайта. Профилът ви остава, а отзивите ви, които не са премахнати, може да изтриете по всяко време. Ако смятате, че е станала
        грешка, пишете ни.
      </p>

      <h2>Връзки към книжарници</h2>
      <p>
        {/* verified: seeds/works.discworld.json (every link is an outbound link with no query string or affiliate parameter); src/app/routes/Book.tsx (rel="nofollow noopener") */}
        Връзките „Къде да я купите“ водят към външни книжарници. Сайтът не е страна по покупката, не получава комисиона, а цените и
        наличността са на книжарниците, към които водят връзките.
      </p>

      <h2>Без гаранция</h2>
      <p>Редът за четене е мнение. Сайтът може да греши, и това не е нарушение на нищо.</p>

      {/* Donations (issue #56, undecided) would go here: what a donation is, that it buys nothing,
          whether it is refundable, and who processes it. Left out until they exist. */}

      <h2>Приложимо право</h2>
      <p>За тези условия се прилага българското право.</p>
    </>
  )
}

export function TermsEn() {
  return (
    <>
      <h2>What the site is</h2>
      <p>
        Чети по реда ("read in order") is an unofficial fan catalogue of reading orders for large fantasy worlds. It is free and has no
        advertising. It is not affiliated with the authors, their estates or the publishers.
      </p>

      <h2>Whose the content is</h2>
      <p>
        The notes, synopses and reading paths were written for this site. The books, their titles and their translations belong to their
        rights holders.
      </p>

      <h2>Accounts</h2>
      <p>
        An account is optional: the catalogue can be read without one. Registration needs a confirmed email address. You can delete your
        account at any time from the <Link to="/account">account page</Link>. Accounts are not offered to children under the age of 14
        without a parent's consent. If we learn that an account belongs to a child under the age of 14, it will be deleted.
      </p>

      <h2>When readers write</h2>
      <p>
        This section applies to reviews on book pages, and to discussions if the site ever has them. No abuse, no spam, and no spoilers
        without a warning. The person running the site may remove anything written here. If your review is removed, you are sent the
        reason by email, at your account's address.
      </p>
      <p>
        After a second review of yours is removed, you cannot write or edit reviews for 30 days; after a third, you no longer can. Your
        account stays, and you can delete your reviews that have not been removed at any time. If you think a mistake has been made, write to us.
      </p>

      <h2>Links to bookshops</h2>
      <p>
        The "where to buy" links lead to external bookshops. The site is not a party to any purchase, takes no commission, and prices and
        availability belong to the shop.
      </p>

      <h2>No warranty</h2>
      <p>A reading order is an opinion. The site can be wrong, and being wrong breaches nothing.</p>

      <h2>Governing law</h2>
      <p>These terms are governed by Bulgarian law.</p>
    </>
  )
}
